<template>
  <Content
    :title="$t('FINANCE.SALES_INVOICE.TITLE')"
    :hint="$t('HINT.FINANCE.INVOICES')"
  >
    <hr class="divider" />

    <SalesReportsInvoices />

    <hr class="divider" />

    <SalesReportsFile />
  </Content>
</template>

<script>
import Content from '@@/common/layout/Content';

import SalesReportsInvoices from './SalesReportsInvoices';
import SalesReportsFile from './SalesReportsFile';

import layout from '@/mixins/layout';

export default {
  name: 'SalesReportss',

  components: {
    Content,
    SalesReportsInvoices,
    SalesReportsFile,
  },

  mixins: [layout],

  created() {
    this.setPageTitle('FINANCE');
  },
};
</script>
